import i18n from '@/config/i18n'
import store from '@/store'
import {
  getDocumentLanguage,
  normalizeLanguage,
  resolveInitialLanguage,
  SupportedLanguage,
} from '@/scripts/root/language'

const syncI18nLanguage = (lang: SupportedLanguage) => {
  i18n.global.locale.value = lang
}

const setLang = (lang: string): void => {
  const selectedLang = normalizeLanguage(lang) || resolveInitialLanguage()

  syncI18nLanguage(selectedLang)
  store.commit('setAppLanguage', selectedLang)
  document.documentElement.setAttribute(
    'lang',
    getDocumentLanguage(selectedLang)
  )
}

export default setLang
